import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-valuer-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-valuer-pv.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationValuerPvConstants } from "./create-application-valuer-pv.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationValuerPvComponent = class CreateApplicationValuerPvComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    recipientSelectService;
    aflaModuleStrategyService;
    appController;
    recipientListService;
    changeDetectorRefs;
    municipalValuerFormControlName = CreateApplicationValuerPvConstants.MUNICIPAL_VALUER_FORM_CONTROL_NAME;
    assistantValuerFormControlName = CreateApplicationValuerPvConstants.ASSISTANT_VALUER_FORM_CONTROL_NAME;
    dataCollectorFormControlName = CreateApplicationValuerPvConstants.DATA_COLLECTOR_FORM_CONTROL_NAME;
    valuerForm;
    municipalValuerDisableFilterBy = false;
    municipalValuerDisableAdd = true;
    municipalValuerDisableEditing = true;
    municipalValuerShowFields = true;
    municipalValuerGroups = [];
    municipalValuerLabel = CreateApplicationValuerPvConstants.MUNICIPAL_LABEL;
    assistantValuerLabel = CreateApplicationValuerPvConstants.ASSISTANT_VALUER_LABEL;
    assistantValuerDisableFilterBy = false;
    assistantValuerDisableAdd = true;
    assistantValuerDisableEditing = false;
    assistantValuerGroups = [];
    assistantValuerListLabel = CreateApplicationValuerPvConstants.ASSISTANT_VALUERS_LABEL;
    dataCollectorListLabel = CreateApplicationValuerPvConstants.DATA_COLLECTORS_LABEL;
    dataCollectorDisableFilterBy = false;
    dataCollectorDisableAdd = true;
    dataCollectorDisableEditing = false;
    dataCollectorGroups = [];
    constructor(createApplicationService, recipientSelectService, aflaModuleStrategyService, appController, recipientListService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            if (this.appController.moduleSimulateMode) {
                this.dataCollectorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.municipalValuerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.assistantValuerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
            }
            else {
                this.dataCollectorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.dataCollectorGroup);
                this.municipalValuerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.municipalValuerGroup);
                this.assistantValuerGroups = this.recipientListService.checkStepMetaRecipientGroups(stepMeta.assistantValuerGroup);
            }
            this.changeDetectorRefs.detectChanges();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("valuerForm");
        form.clearValidators();
        this.valuerForm = form;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: RecipientListService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationValuerPvComponent = __decorate([
    Component({
        selector: "app-create-application-valuer-pv",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationValuerPvComponent);
export { CreateApplicationValuerPvComponent };
